module.exports = __webpack_public_path__ + "static/img/2.406b18d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail1/2.png
// module id = +UC2
// module chunks = 19